import { createApp } from 'vue'
import App from './App.vue'
import router from './router'; // Import the router
import store from './store'; // Import the Vuex store
import UrlLoaderService from './services/urlLoader';

const app = createApp(App);

// Provide the UrlLoaderService globally
app.provide('$urlLoader', UrlLoaderService);

app.use(router).use(store).mount('#app');
